module.exports = __webpack_public_path__ + "img/online-learning-1.9e939fe.jpg";